export enum InvoiceStatus {
  Unpaid = 1,
  Paid = 2,
  Deleted = 3,
  Canceled = 4,
}
